import { render, staticRenderFns } from "./customRadio.vue?vue&type=template&id=533b1ea7&scoped=true"
import script from "./customRadio.vue?vue&type=script&lang=ts"
export * from "./customRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b1ea7",
  null
  
)

export default component.exports